import { IAdvertChannelRepository } from '../../application/ports/IAdvertChannelRepository';
import axios from 'axios';
import { advertizerApiHost } from '../../constants/envs';
import { AuthTokenProvider } from '../auth/AuthTokenProvider';

export class AdvertChannelsAxiosRepository implements IAdvertChannelRepository {
  constructor(private auth: AuthTokenProvider) {}

  private async headers() {
    const token = await this.auth.getToken();
    if (!token) throw new Error('Unauthenticated');
    return { Authorization: `Bearer ${token}` };
  }

  async getByAdvert(advertUUID: string): Promise<string[]> {
    const res = await axios.get(advertizerApiHost + '/api/advert_channels', { params: { advertUUID }, headers: await this.headers() });
    // API returns channels array with uuid
    return (res.data.channels || []).map((c: any) => c.uuid);
  }

  async setForAdvert(advertUUID: string, channelUUIDs: string[], telegramAccountUUIDs?: string[]): Promise<void> {
    const body = telegramAccountUUIDs ? { advertUUID, channelUUIDs, telegramAccountUUIDs } : { advertUUID, channelUUIDs };
    await axios.post(advertizerApiHost + '/api/advert_channels', body, { headers: await this.headers() });
  }

  async getTelegramAccountsByAdvert(advertUUID: string): Promise<string[]> {
    const res = await axios.get(advertizerApiHost + `/api/adverts/${advertUUID}/telegram_accounts`, { headers: await this.headers() });
    return res.data.telegramAccountUUIDs || [];
  }
}
